<template>
  <b-row>
    <b-col cols="12" class="mb-2">
      <b-row>
        <b-col cols="6" md="3">
          <b-card>
            <b-card-body>
              <b-row>
                <b-col md="12">
                  <h4 class="font-weight-bold text-nowrap">
                    Active Promotions
                  </h4>
                </b-col>
                <b-col md="12">
                  <div class="d-flex align-items-end">
                    <h1 class="text-primary mb-0" style="line-height: 1">18</h1>
                    <div class="d-flex align-items-center ml-1">
                      <feather-icon class="text-success" icon="ArrowUpIcon" />
                      <span class="">8.5%</span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" md="3">
          <b-card>
            <b-card-body>
              <b-row>
                <b-col md="12">
                  <h4 class="font-weight-bold text-nowrap">
                    Scheduled Promotions
                  </h4>
                </b-col>
                <b-col md="12">
                  <div class="d-flex align-items-end">
                    <h1 class="text-primary mb-0" style="line-height: 1">12</h1>
                    <div class="d-flex align-items-center ml-1">
                      <feather-icon class="text-success" icon="ArrowUpIcon" />
                      <span class="">9.3%</span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" md="3">
          <b-card>
            <b-card-body>
              <b-row>
                <b-col md="12">
                  <h4 class="font-weight-bold text-nowrap">
                    Promo Value Distributed
                  </h4>
                </b-col>
                <b-col md="12">
                  <div class="d-flex align-items-end">
                    <h1 class="text-primary mb-0" style="line-height: 1">
                      $124.5k
                    </h1>
                    <div class="d-flex align-items-center ml-1">
                      <feather-icon class="text-success" icon="ArrowUpIcon" />
                      <span class="">12.3%</span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" md="3">
          <b-card>
            <b-card-body>
              <b-row>
                <b-col md="12">
                  <h4 class="font-weight-bold text-nowrap">
                    Promo Conversion Rate
                  </h4>
                </b-col>
                <b-col md="12">
                  <div class="d-flex align-items-end">
                    <h1 class="text-primary mb-0" style="line-height: 1">
                      8.2%
                    </h1>
                    <div class="d-flex align-items-center ml-1">
                      <feather-icon class="text-danger" icon="ArrowDownIcon" />
                      <span class="">8.2% </span>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="12">
      <!-- Upcoming Fixtures -->
      <b-card>
        <b-row class="d-flex align-items-center">
          <b-col cols="8">
            <h4 class="font-weight-bolder mb-0">Active Promotions</h4>
          </b-col>
          <b-col cols="4" class="text-right">
            <b-button size="md" variant="primary" @click="showModalPromotions">
              <feather-icon icon="PlusIcon" />
              <span class="text-lg text-nowrap" style="margin-left: 4px"
                >Create promotions</span
              >
            </b-button>
          </b-col>
        </b-row>

        <b-table
          ref="refPromotionTable"
          class="mt-2"
          :items="fetchPromotionList"
          :fields="tableColumns"
          responsive
          show-empty
          primary-key="campaign"
        >
          <template #empty>
            <div v-if="loadingList" class="text-center text-dark my-2">
              <p>Loading... Please wait</p>
            </div>

            <div
              v-else-if="!loadingList && fetchPromotionList.length === 0"
              class="text-center text-dark my-2"
            >
              No matching records found
            </div>
          </template>

          <template #cell(status)="{ item }">
            <b-media vertical-align="center">
              <b-badge
                pill
                :variant="item.status === 'active' ? 'success' : 'danger'"
              >
                {{ item.status === "active" ? "Active" : "Inactive" }}
              </b-badge>
            </b-media>
          </template>

          <template #cell(actions)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center">
                <feather-icon
                  size="16"
                  icon="EditIcon"
                  class="mr-1 text-primary cursor-pointer"
                  @click="handleRedirect(item)"
                />
                <feather-icon
                  size="16"
                  icon="TrashIcon"
                  class="mr-1 text-danger cursor-pointer"
                  @click="showModal('delete', item)"
                />
              </div>
            </b-media>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">
                Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                {{ dataMeta.of }} promotion(s)
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalPromotions"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-col>



    <b-col cols="12">
      <b-row>
        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <b-card-body>
              <b-row>
                <b-col md="12">
                  <h5
                    class="text-body font-weight-bold text-nowrap text-center"
                  >
                    Deposit Match Offers
                  </h5>
                </b-col>
                <b-col md="12">
                  <h2 class="mb-0 text-center">8</h2>
                  <span
                    class="d-inline-block w-100 text-muted text-center mx-auto"
                    >Total value: $56,000</span
                  >
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <b-card-body>
              <b-row>
                <b-col md="12">
                  <h5
                    class="text-body font-weight-bold text-nowrap text-center"
                  >
                    Money Back Specials
                  </h5>
                </b-col>
                <b-col md="12">
                  <h2 class="mb-0 text-center">6</h2>
                  <span
                    class="d-inline-block w-100 text-muted text-center mx-auto"
                    >Total value: $49,000</span
                  >
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <b-card-body>
              <b-row>
                <b-col md="12">
                  <h5
                    class="text-body font-weight-bold text-nowrap text-center"
                  >
                    Odds Boost
                  </h5>
                </b-col>
                <b-col md="12">
                  <h2 class="mb-0 text-center">4</h2>
                  <span
                    class="d-inline-block w-100 text-muted text-center mx-auto"
                    >Total value: $27,000</span
                  >
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <b-card-body>
              <b-row>
                <b-col md="12">
                  <h5
                    class="text-body font-weight-bold text-nowrap text-center"
                  >
                    Price Promotions
                  </h5>
                </b-col>
                <b-col md="12">
                  <h2 class="mb-0 text-center">3</h2>
                  <span
                    class="d-inline-block w-100 text-muted text-center mx-auto"
                    >Total value: $36,000</span
                  >
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-col>

    <b-modal
      ref="promotion"
      title="Create Promotion"
      centered
      cancel-disabled
      :ok-disabled="isSubmitting"
      @ok="handleSubmitModal"
      footer-class="border-0"
      size="lg"
      dialog-class="custom-width"
      hide-footer
    >
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <p class="text-body mb-1" style="font-size: 16px">
              Select the type of promotion you want to create for your business
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="4">
            <b-card
              class="cursor-pointer"
              @click="$router.push('/promotions/deposit-match/new')"
            >
              <div class="d-flex align-items-center" style="gap: 16px">
                <feather-icon
                  icon="PercentIcon"
                  class="text-primary"
                  size="20"
                />
                <div>
                  <p class="text-body fontspanweight-bolder mb-0">
                    Deposit Match Offers
                  </p>
                  <span class="text-muted">8 promotions</span>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <span class="text-nowrap text-muted">Total value: $56,000</span>
                <div
                  class="d-flex align-items-center ml-1"
                  style="cursor: pointer"
                >
                  <span class="text-primary" style="text-decoration: underline"
                    >Manage</span
                  >
                  <feather-icon icon="ArrowRightIcon" class="text-primary" />
                </div>
              </div>
            </b-card>
          </b-col>

          <b-col cols="12" md="4">
            <b-card
              class="cursor-pointer"
              @click="$router.push('/promotions/money-back-specials/new')"
            >
              <div class="d-flex align-items-center" style="gap: 16px">
                <feather-icon icon="PercentIcon" class="text-info" size="20" />
                <div>
                  <p class="text-body font-weight-bolder mb-0">
                    Money Back Special
                  </p>
                  <span class="text-muted">6 promotions</span>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <span class="text-nowrap text-muted">Total value: $49,000</span>
                <div
                  class="d-flex align-items-center ml-1"
                  style="cursor: pointer"
                >
                  <span class="text-primary" style="text-decoration: underline"
                    >Manage</span
                  >
                  <feather-icon icon="ArrowRightIcon" class="text-primary" />
                </div>
              </div>
            </b-card>
          </b-col>

          <b-col cols="12" md="4">
            <b-card
              class="cursor-pointer"
              @click="$router.push('/promotions/odd-boost/new')"
            >
              <div class="d-flex align-items-center" style="gap: 16px">
                <feather-icon icon="ZapIcon" class="text-info" size="20" />
                <div>
                  <p class="text-body font-weight-bolder mb-0">Odds Boost</p>
                  <span class="text-muted">4 promotions</span>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <span class="text-nowrap text-muted"
                  >Total value: $128,000</span
                >
                <div
                  class="d-flex align-items-center ml-1"
                  style="cursor: pointer"
                >
                  <span class="text-primary" style="text-decoration: underline"
                    >Manage</span
                  >
                  <feather-icon icon="ArrowRightIcon" class="text-primary" />
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="4">
            <b-card
              class="cursor-pointer"
              @click="$router.push('/promotions/price-promotions/new')"
            >
              <div class="d-flex align-items-center" style="gap: 16px">
                <feather-icon icon="ZapIcon" class="text-info" size="20" />
                <div>
                  <p class="text-body font-weight-bolder mb-0">
                    Price Promotions
                  </p>
                  <span class="text-muted">4 promotions</span>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <span class="text-nowrap text-muted"
                  >Total value: $128,000</span
                >
                <div
                  class="d-flex align-items-center ml-1"
                  style="cursor: pointer"
                >
                  <span class="text-primary" style="text-decoration: underline"
                    >Manage</span
                  >
                  <feather-icon icon="ArrowRightIcon" class="text-primary" />
                </div>
              </div>
            </b-card>
          </b-col>

        </b-row>
      </b-container>
    </b-modal>

    <!-- MODAL CONFIRM -->
    <b-modal
      ref="modal"
      :title="modal.title"
      centered
      cancel-variant="outline-secondary"
      :ok-disabled="isSubmitting"
      @ok="handleSubmitModal"
    >
      <b-card-text style="color: black">
        {{ modal.content }}
      </b-card-text>
      <template #modal-ok>
        <Spinner v-if="isSubmitting" />
        <span v-else>Submit</span>
      </template>
    </b-modal>
  </b-row>
</template>
<script>
import {
  BCard,
  BTable,
  BFormCheckbox,
  BButton,
  BAlert,
  BFormGroup,
  BRow,
  BCol,
  BFormRadio,
  BFormRadioGroup,
  BFormInput,
  BPagination,
  BMedia,
  BModal,
  BCardBody,
  BBadge,
} from "bootstrap-vue";
import VSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import { mapActions, mapState } from "vuex";
import useToastHandler from "@/services/toastHandler";
import { computed, ref, watch } from "@vue/composition-api";
import { addDays, endOfDay, startOfDay } from "date-fns";

export default {
  components: {
    BModal,
    BCard,
    BTable,
    BFormCheckbox,
    BButton,
    BAlert,
    BFormGroup,
    BRow,
    BCol,
    VSelect,
    flatPickr,
    FeatherIcon,
    BFormRadio,
    BFormRadioGroup,
    BFormInput,
    BPagination,
    BMedia,
    BCardBody,
    BBadge,
  },
  data() {
    return {
      tableColumns: [
        { key: "name", label: "PROMOTION NAME" },
        { key: "type", label: "TYPE" },
        { key: "targetAudience", label: "TARGET AUDIENCE" },
        { key: "budget", label: "BUDGET" },
        { key: "redemptionRate", label: "REDEMPTION RATE" },
        { key: "status" },
        { key: "actions" },
      ],
      action: {
        type: "",
        item: "",
      },
      modal: {
        title: "",
        content: "",
      },
    };
  },
  computed: {
    ...mapState("promotions/list", ["loadingList", "loadingDeletePromotion"]),
    isSubmitting() {
      return this.loadingDeletePromotion;
    },
  },
  methods: {
    ...mapActions({
      getPromotionsList: "promotions/list/getPromotionsList",
      deletePromotion: "promotions/list/deletePromotion",
    }),
    showModalPromotions() {
      this.$refs.promotion.show();
    },
    async fetchPromotionList() {
      const data = await this.getPromotionsList({
        page: this.currentPage,
        limit: this.perPage,
        onlyActive: true,
      });
      this.totalPromotions = data.pagination.total;

      if (!data)
        return this.showToastError(false, "Error fetching promotions list");
      return data.data;
    },
    handleRedirect(item) {
      if (item.type === "Boost")
        return this.$router.push(`/promotions/odd-boost/${item.id}`);
      if (item.type === "Money Back Specials")
        return this.$router.push(`/promotions/money-back-specials/${item.id}`);
       if (item.type === "Price")
         return this.$router.push(`/promotions/price-promotions/${item.id}`);
      if (item.type === "Deposit")
        return this.$router.push(`/promotions/deposit-match/${item.id}`);
    },
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },

    showModal(type, item) {
      this.action = { item, type };
      if (type === "delete") {
        this.setModal(
          "Delete Promotion",
          `Are you sure you want to delete the promotion ${item.id}?`
        );
      }
      this.$refs.modal.show();
    },

    async handleSubmitModal(event) {
      event.preventDefault();
      const { item, type } = this.action;

      if (type === "delete") await this.handleDeletePromotion(item);

      if (!this.isSubmitting) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleDeletePromotion(item) {
      const res = await this.deletePromotion(item.id);
      if (res) {
        this.showToastSuccess(true, "Promotion deleted successfully!");
        this.refetchData();
      }
    },
  },
  setup() {
    const refPromotionTable = ref(null);
    const totalPromotions = ref(0);
    const currentPage = ref(1);
    const perPage = ref(10);

    const dataMeta = computed(() => {
      const localItemsCount = refPromotionTable.value
        ? refPromotionTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalPromotions.value,
      };
    });

    const refetchData = () => {
      refPromotionTable.value.refresh();
    };

    watch([currentPage], () => {
      refetchData();
    });

    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      formatCurrencyBuiltInFunc,

      showToastError,
      showToastSuccess,
      refPromotionTable,

      totalPromotions,
      currentPage,
      perPage,
      dataMeta,
      refetchData,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.btn-action {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid var(--bg-color);
  svg {
    color: var(--bg-color);
  }
  &:hover {
    background: var(--bg-color);
    svg {
      color: white;
    }
  }
}
.promotion-type {
  background: var(--bg-color);
  color: var(--color);
}
.custom-width {
  max-width: fit-content !important;
}
</style>
